import { ca } from '@cian/analytics';

import { TSellerType } from '../NewbuildingCallButton/tracking';

/** Откуда добавили в избранное — уходит в page.extra.source. */
export type TFavoriteSource = 'gallery' | 'infrastructure';

export interface ITrackAddFavoriteGallery {
  newbuildingId: number;
  url?: string;
  sellerType: TSellerType;
  source?: TFavoriteSource;
}

export function trackAddFavoriteGallery({
  newbuildingId,
  url,
  sellerType,
  source = 'gallery',
}: ITrackAddFavoriteGallery) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'add_from_compare_jk',
    label: url,
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      extra: {
        seller_type: sellerType,
        source,
      },
    },
  });
}
